export default {
  "content": "<path d=\"M9 18.5H6.5v-13H9v13zM17.5 18.5H15v-13h2.5v13z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};